import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { Link, useHistory, useLocation } from 'react-router-dom'
import GiveVirtualGiftPopup from '../../popups/giveVirtualGiftPopup/GiveVirtualGiftPopup'

import { createLocalizedPath } from '../../../../utils/localizationHelpers'
import moment from 'moment-mini'
// import ReactTooltip from 'react-tooltip'
import { RootState } from '../../../../store/rootReducer'
import paths from '../../../../paths'
import { MemberState, MyGift } from '../../../../store/member/memberTypings'
import { switchMenu } from '../../../../store/common/commonSlice'
import { giftDelete } from '../../../../api/gifts'
import { fetchSavedGifts } from '../../../../store/member/memberSlice'
import './notSentGifts.sass'

type Props = {
    giftInfo: MyGift
    album?: boolean
    catalog?: boolean
    recipient?: string
    isOutgoing?: boolean
    currentPage?: number
    setCurrentPage?: React.Dispatch<number>
}

export const GiftConstructor = ({ giftInfo, album = false, catalog = false, isOutgoing, recipient = '' }: Props) => {
    const dispatch = useDispatch()
    const [t] = useTranslation()
    const generateId = () => giftInfo.gift_name + giftInfo.gift_id
    const [popupState, setPopupState] = useState(false)

    const { user } = useSelector<RootState, MemberState>((state) => state.member)

    const nickInGift = giftInfo.sender ? giftInfo.sender.nick : giftInfo.receiver ? giftInfo.receiver.nick : null

    if (catalog)
        return (
            <>
                <div
                    className={'giftConstructor giftCatalog'}
                    onClick={() => {
                        user ? setPopupState(true) : dispatch(switchMenu())
                    }}
                >
                    <img src={giftInfo.image} data-tip="" data-for={generateId()} />
                    <div>
                        <p>{giftInfo.gift_name}</p>
                        <p className={'sentDate'}>{giftInfo.points + ' ' + t('tokens')}</p>
                    </div>
                </div>
                {/*<ReactTooltip arrowColor={'transparent'} type={'light'} id={generateId()} className={'giftTooltip'}>*/}
                {/*    <img src={giftInfo.image} />*/}
                {/*</ReactTooltip>*/}
                <GiveVirtualGiftPopup
                    gift={giftInfo}
                    recipient={recipient ? recipient : nickInGift}
                    externalState={popupState}
                    setExternalState={setPopupState}
                />
            </>
        )
    return (
        <>
            <img src={giftInfo.image} />
            <p>
                {isOutgoing
                    ? giftInfo.gift_name + ' ' + t('to give to') + ' '
                    : giftInfo.gift_name + ' ' + t('given by') + ' '}
                {nickInGift ? (
                    <Link
                        to={{
                            pathname: createLocalizedPath(`/profil/${nickInGift}`)
                        }}
                        className={'nickLink'}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {nickInGift}
                    </Link>
                ) : (
                    t('an anonymous')
                )}
            </p>
            {!album && (
                <div>
                    <p className={'sentDate'}>{moment(giftInfo.date * 1000).format('DD/MM/YYYY')}</p>
                    <p className={'priceTokens'}>{giftInfo.points + ' ' + t('tokens')}</p>
                </div>
            )}
        </>
    )
}

const NotSentGift = ({ giftInfo, currentPage, setCurrentPage }: Props) => {
    const history = useHistory()
    const location = useLocation()
    const dispatch = useDispatch()

    const [popupState, setPopupState] = useState(false)

    const { savedGiftsTotal } = useSelector((state: RootState) => state.member)

    useEffect(() => {
        if (new URLSearchParams(location.search).get('id') === String(giftInfo.id)) setPopupState(true)
    }, [])

    return (
        <>
            <div className={'giftConstructor'}>
                <GiftConstructor giftInfo={giftInfo} isOutgoing={true} />
                <div className="giftButtonContainer">
                    <img
                        src={require('./../../../../assets/ic-edit.svg')}
                        onClick={(e) => {
                            e.stopPropagation()
                            history.replace({
                                pathname: createLocalizedPath(paths.myWallet.path),
                                search: `?id=${giftInfo.id}`
                            })
                            setPopupState(true)
                        }}
                    />
                    <img
                        src={require('./../../../../assets/ic-delete.svg')}
                        onClick={(e) => {
                            e.stopPropagation()
                            giftDelete({ id: giftInfo.id }).then(() => {
                                if ((savedGiftsTotal - 1) % 20 !== 0) {
                                    dispatch(fetchSavedGifts({ p: currentPage }))
                                } else {
                                    setCurrentPage(currentPage - 1)
                                }
                            })
                        }}
                    />
                </div>
            </div>
            <GiveVirtualGiftPopup
                gift={giftInfo}
                recipient={giftInfo.sender || giftInfo.receiver.nick}
                externalState={popupState}
                setExternalState={setPopupState}
            />
        </>
    )
}

export default NotSentGift
